import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import { getLocalJSON, isValidStored } from '../../_helpers/storage.util';
declare var $:any;

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent {

  public loginTrue:boolean= false;
  public FaqList:any =[];
  public loginDetail:any =[];
  public backFile:any='';
  public loading:boolean = false;
  public showButton:boolean=true;
  public FaqOtherDetail:any=[];
  public Faqdata:any=[];

  constructor(public router: Router, private service: GlobalService) {
    if(isValidStored('grw_login')){
      this.loginTrue = true;
    }
    this.loginDetail = getLocalJSON('grw_login');
    this.getFaqs();
   }

  getFaqs(){
    const url = "/faq"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        var self=this;
        response.data.faq.filter((el:any)=>{
          if(self.loginTrue){
            if(el.forLoggedIn){
              self.FaqList.push(el)
            }
          } else {
            if(!el.forLoggedIn){
              self.FaqList.push(el)
            }
          }
        })
        this.FaqOtherDetail = response.data.content;
        this.Faqdata=response.data;
        if(this.loginTrue){
        $('#texts').removeClass('container');
        $('#texts').addClass('page-wrapper');
      } else {
        $('#texts').addClass('container');
        $('#texts').removeClass('page-wrapper');
      }
      }
    }), (error) => { this.loading =false; });
  }

  downloadFile(url: any) {
    fetch(url)
      .then((res) => res.blob())
      .then((file) => {
        let tempUrl = URL.createObjectURL(file);
        const aTag = document.createElement("a");
        aTag.href = tempUrl;
        aTag.download = url.replace(/^.*[\\\/]/, "");
        document.body.appendChild(aTag);
        aTag.click();
        URL.revokeObjectURL(tempUrl);
        aTag.remove();
      })
      .catch(() => {
        this.service.dangerAlert("Please contact administrator");
      });
  }

  plays(){
    var ss:any= document.getElementById("myAudio1");
    if(ss.paused){
     ss.play();
     this.showButton=false;
    } else {
     ss.pause();
     this.showButton=true;
    }  
   }

   scrollTop() {
    window.scroll(0,2000);
    // $('html, body').animate({scrollTop:0}, '0');
  }
}
